import { InjectionToken } from '@angular/core';

export const LOCATION_TOKEN = new InjectionToken<Location>(
  'Window location object'
);
export function locationProvider() {
  return location;
}
